import { roundDollars } from './roundDollars'

export default function roundDollarsInString(str: string, nearest: number) {
  return str.replace(/\$([\d,]+(?:\.\d+)?)/g, (_, num) => {
    let n = parseFloat(num.replace(/,/g, ''))
    n = roundDollars(n, nearest)
    return `$${n.toLocaleString()}`
  })
}
